import { MainSettings, NotesFontSize, ThemeType } from 'src/app/model/settings.model';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// quando pegava direto do firestore
//import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { Firestore, doc, getFirestore, onSnapshot, updateDoc} from 'firebase/firestore';
//import { docData} from '@angular/fire/firestore';
import { docData } from '../../utils/custom-firestore.utils';
import { AuthService } from '../authentication/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  mainSettingsObservable: Observable<MainSettings> = null;

  selectedMenu = "home";
  reviewsTabActive = false;

  settingsChange = new Subject<MainSettings>();


  mainSettings: MainSettings = null;

  private firestore: Firestore = getFirestore();

  constructor(private authService: AuthService) {

      const userSubscription = this.authService.user$.subscribe(user => {

        if (user) {
          this.startListenSettingsChange(user.uid);
          userSubscription.unsubscribe();
          this.detectSystemThemeChange();
        }
      });
  }

  isChromeExtension () {
    return environment.environmentName === 'extension';
  }

  getChromeExtensionId () {
    return environment.chromeExtensionId;
  }


  getWebUrl() {
    return environment.webUrl;
  }

  getCloudFunctionsUrl() {
    return environment.cloudFunctionsUrl;
  }

  getCloudFunctionsRegion() {
    return environment.cloudFunctionsRegion;
  }

  private detectSystemThemeChange() {
    // Define a query para detectar o tema preferido do sistema
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    // Adiciona um listener para mudanças na preferência do tema
    prefersDark.addEventListener('change', (e) => {
      if (this.mainSettings.theme === 'System') {
       this.settingsChange.next(this.mainSettings);
      }
    });
  }

  updateMainSettings(settings: Partial<MainSettings>): Promise<void> {
    // Referência ao documento no Firestore
    const settingsDocRef = doc(
      this.firestore,
      `users/${this.authService.userId}/settings/main_settings`
    );

    // Atualiza os campos especificados no Firestore
    return updateDoc(settingsDocRef, settings);
  }

  startListenSettingsChange(userId: string) {

    // quando pegava direto do firebase
    // const db = getFirestore(); // Assumindo que o Firebase já foi inicializado


    const settingsRef = doc(this.firestore, `users/${userId}/settings/main_settings`);


    onSnapshot(settingsRef, (snapshot) => {
      this.mainSettings = snapshot.data() ? (snapshot.data() as MainSettings) : null;
      console.log('Settings changed:', this.mainSettings);
      if (this.mainSettings)
        this.settingsChange.next(this.mainSettings);
    }, error => {
      console.error('Erro ao pegar configurações setting SErvices:', error);
    });
  }

  // Método para obter o Observable do tema
  /**
   * Returns an observable that emits the main settings for the given user ID.
   * If no user ID is provided, it uses the current authenticated user's ID.
   * If no main settings observable exists, it creates one and returns it.
   * @param uid The user ID to get the main settings for.
   * @returns An observable that emits the main settings for the given user ID.
   */
  getThemeObservable(uid?: string): Observable<MainSettings> | null {
    if (!uid && !this.mainSettingsObservable) {
      return null;
    }

    if (!this.mainSettingsObservable) {
      const settingsDocRef = doc(
        this.firestore,
        `users/${uid}/settings/main_settings`
      );

      this.mainSettingsObservable = docData(settingsDocRef) as Observable<MainSettings>;
    }

    return this.mainSettingsObservable;
  }

  getLogoPath() {
    const mainSettings = this.mainSettings;

    //const theme = mainSettings?.theme ?? ThemeType.SYSTEM;

    // There are no user settings on public pages, so their light theme must
    // also use the light logo. Logged-in users keep their saved preference.
    if (!mainSettings) {
      return "/assets/images/logo-light.svg";
    }

    const theme = mainSettings.theme;

    if (theme === ThemeType.SYSTEM) {
      const isSystemThemeDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      return isSystemThemeDark ? "/assets/images/logo-dark.svg" : "/assets/images/logo-light.svg";
    } else if (theme === ThemeType.DARK) {
      return "/assets/images/logo-dark.svg";
    } else {
      return "/assets/images/logo-light.svg";
    }
  }

  getNotesFontSize() {

    if (this.isChromeExtension())
      return '14px';

    // return '14px' if small, '16px' if medium, '18px' if large
    const fontSize = this.mainSettings?.fontSettings?.notesFontSize ?? NotesFontSize.SMALL;
    switch (fontSize) {
      case NotesFontSize.SMALL:
        return '14px';
      case NotesFontSize.MEDIUM:
        return '16px';
      case NotesFontSize.LARGE:
        return '18px';
      default:
        return '14px';
    }
  }

}
